import { UseGetProductResponse } from "../types/queries";

import { getFirstStringValue } from "./get-first-string-value";
import { getUpsellPriceFromProduct } from "./legacy/extras-utils";

export const getPageUpsellPrice = (
  data: qs.ParsedQs,
  product: UseGetProductResponse
) => {
  if (!data) {
    return null;
  }

  const customisations = Object.entries(data);

  if (customisations.length === 0) {
    // This could be true when the user submits a modal such as in the preview screen
    // of me and my big brother. If the user chooses to change the child details,
    // then there's no customisation data to process
    return null;
  }

  const result: { [key: string]: number } = {};

  // Some customisations might include multiple items, such as when adding a
  // dedication and a photo upload. We need to process each one
  customisations.forEach((customisation) => {
    const [customisationName, customisationValue] = customisation;
    let parsedCustomisationValue = getFirstStringValue(customisationValue);

    const price = getUpsellPriceFromProduct(
      customisationName,
      parsedCustomisationValue,
      product as UseGetProductResponse
    );

    if (price === null) {
      return;
    }

    result[customisationName] = Number(price?.toFixed(2));
  });

  if (Object.keys(result).length === 0) {
    return null;
  }

  return result;
};
